import { Injectable } from '@angular/core';
import { add } from 'date-fns';
import { map, Observable, of, tap } from 'rxjs';

import { ProviderAvailability, SchedulingAvailabilityService, TimeSlot } from '@sondermind/data-access/scheduling';

import { IAppointmentSlot } from '../models/public-provider-calendar.interface';

@Injectable({
  providedIn: 'root'
})
export class ProviderCalendarStore {
  private cachedAppointmentSlots: Record<number, IAppointmentSlot[]> = {};

  constructor(private schedulingAvailabilityService: SchedulingAvailabilityService) {}

  getAppointmentSlots$(
    providerPersonaId: number,
    providerTimeZone: string,
    forceRefresh = false
  ): Observable<IAppointmentSlot[]> {
    if (!forceRefresh && this.cachedAppointmentSlots[providerPersonaId]) {
      return of(this.cachedAppointmentSlots[providerPersonaId]);
    }

    const start = add(new Date(), { days: 2 });
    const end = add(new Date(), { days: 29 });

    return this.schedulingAvailabilityService
      .getAvailabilityForPublicProviders([providerPersonaId], start, end)
      .pipe(
        map((availability: ProviderAvailability) => {
          const timeSlots: TimeSlot[] = availability.providerSlots.get(providerPersonaId) ?? [];
          return timeSlots.map((ts) => ({
            displayStartTime: ts.start,
            utcStartTime: ts.start,
            utcEndTime: ts.end,
          }));
        }),
        tap((slots) => {
          this.cachedAppointmentSlots[providerPersonaId] = slots;
        })
      );
  }
}
